import React, { useEffect, useRef, useState } from 'react';
import spotifyScreenshot from '@/assets/spotify-screenshot.png';

export function SpotifyPhoneMockup() {
  return (
    <div className="relative w-full max-w-[260px] lg:max-w-[370px] mx-auto">
      {/* Blue-to-Purple Glow Background */}
      <div 
        className="absolute inset-0 -z-10"
        style={{
          background: 'radial-gradient(circle at center, hsl(214 100% 45% / 0.15) 0%, hsl(240 100% 50% / 0.12) 35%, transparent 70%)',
          filter: 'blur(50px)',
          transform: 'scale(1.3)',
        }}
      />
      
      {/* iPhone Frame */}
      <div 
        className="relative bg-white rounded-[3rem] p-3 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.2)] lg:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.3)] hover:scale-[1.02] hover:shadow-2xl transition-all duration-500"
        style={{
          filter: 'drop-shadow(0 20px 40px hsl(214 100% 45% / 0.12))',
        }}
      >
        {/* Notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-white rounded-b-3xl z-10" />
        
        {/* Screen */}
        <div className="relative bg-white rounded-[2.5rem] overflow-hidden aspect-[9/19.5]">
          <img 
            src={spotifyScreenshot} 
            alt="Spotify for Artists dashboard showing streaming analytics"
            className="w-full h-full object-cover"
            loading="lazy"
            decoding="async"
            width="370"
            height="800"
          />
        </div>
      </div>
    </div>
  );
}
